var React = require('react');

function IconArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Raggruppa_42","data-name":"Raggruppa 42","transform":"translate(534.19 -603.598) rotate(90)"},[React.createElement("path",{"id":"Tracciato_26","data-name":"Tracciato 26","d":"M0,0,28.045,25.236,55.965,0","transform":"translate(660.569 497.966) rotate(180)","fill":"none","stroke":"#fff","strokeWidth":"3","key":0}),React.createElement("line",{"id":"Linea_39","data-name":"Linea 39","x1":"0.246","y2":"61.37","transform":"translate(632.367 472.813)","fill":"none","stroke":"#fff","strokeWidth":"3","key":1})]));
}

IconArrowRight.defaultProps = {"viewBox":"0 0 63.48 57.974"};

module.exports = IconArrowRight;

IconArrowRight.default = IconArrowRight;
